import React from 'react';
import { Link } from 'react-router-dom';
import Axios from 'axios';
import moment from 'moment';
import { Bar, Doughnut, Line, Pie, Polar, Radar } from 'react-chartjs-2';
import Users from '../users/Users';

import DashMod_Summary01 from './comps/DashMod_Summary01';
import PlayerDashboardOptA from './playerDashboardOptA';
import PlayerDashboardOptB from './playerDashboardOptB';

import AutoSuggestPlayer from '../shared/AutoSuggest/AutoSuggestPlayer';

import * as myConstClass from '../shared/constants/constants';

const CST_PROMO_DATE_01A = '2018-02-27';
const CST_PROMO_DATE_01B = '2018-03-31';

const bar = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
  datasets: [
    {
      label: 'My First dataset',
      backgroundColor: 'rgba(255,99,132,0.2)',
      borderColor: 'rgba(255,99,132,1)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(255,99,132,0.4)',
      hoverBorderColor: 'rgba(255,99,132,1)',
      data: [65, 59, 80, 81, 56, 55, 40]
    }
  ]
};

const autoSuggTheme = {
	container: 'react-autosuggest-std__container',
	input: 'react-autosuggest-std__input',
	inputOpen: 'react-autosuggest-std__input--open',
	inputFocused: 'react-autosuggest-std__input--focused',
	suggestionsContainer: 'react-autosuggest-std__suggestions-container',
	suggestionsContainerOpen: 'react-autosuggest-std__suggestions-container--open',
	suggestionsList: 'react-autosuggest-std__suggestions-list',
	suggestion: 'react-autosuggest-std__suggestion',
	suggestionHighlighted: 'react-autosuggest-std__suggestion--highlighted',
	//suggestionFirst: 'react-autosuggest__suggestion--first',
	//sectionContainer: 'react-autosuggest__section-container',
	//sectionContainerFirst: 'react-autosuggest__section-container--first',
	//sectionTitle: 'react-autosuggest__section-title'
};

const DASHMOD_NBOF_DATACOL = 7;

class playerDashboard extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			profile: this.props.auth.getProfile(),
			isAuthenticated: this.props.auth.isAuthenticated(),
			
			user: {
				playerId: 0,
				playerName: '',
				memberActive: false,
				memberDateExpiration: ''
			},

			players: [],

			dashboardOption: 0,
			resultsTypeSelectorValue: 0,
			resultsType: myConstClass.RESTYPE_ALL,

			leagueTypeSelectorValue: 0,
			leagueType: myConstClass.LGTYPE_8B,
		};
	
		this.handlePlayerChange = this.handlePlayerChange.bind(this);
		this.handleResultsTypeChange = this.handleResultsTypeChange.bind(this);
		this.handleLeagueTypeChange = this.handleLeagueTypeChange.bind(this);
	}

	componentDidMount() {

		// console.log('playerDashboard: componentDidMount');
    // console.log(this.props);

		// Get playerId and info
		var _this = this;
		var profile = this.state.profile;
		var authUserId = profile.user_id;

		if (authUserId !== undefined) {

			Users.getUserInfo(authUserId, function(user) {

				// Validate expiration date, and take action
				var todayDate = moment(new Date());
				var expDate = moment(user.memberDateExpiration);
				var expDelay = Math.ceil((expDate - todayDate) / (24*60*60*1000)); 

				// ------------------------------------------------------------
				// Admin Dashboard for show!
        Users.getAccessLevel(profile, function(globalAccessLevel) {
		
					// PLAYER SELECTION OPEN FOR EVERYONE !
					Axios.get('/api/players').then(function (response) {
						_this.setState({
							user: user,
			        players: response.data,
						});
					});
				});
			});
		}
	}

	render() {
		// console.log('playerDashboard: render - profile');
		// console.log(profile);
		// console.log(this.state.isAuthenticated);
		var profile = this.state.profile;

		return (
			<div className="animated fadeIn">
			<div className="row">
			<div className="col-md-5">
    		<h5>Tableau de Bord</h5>
    		<h5>{this.state.user.playerName}</h5>
			</div>
			<div className="col-md-6">
    		<h5>La puissance des stats</h5>
			</div>

			<div className="col-md-1">
				<br/>
				<Link to="/userAccount">
					<img className="img-circle" src={profile.picture} />
					</Link>
				</div>
   		</div>
			<hr/>

			{this.displayModules()}
   		</div>
		);
	}

	displayModules() {

		var resultsType = this.state.resultsType;
		var leagueType = this.state.leagueType;

		var playerId = this.state.user.playerId;
		var specialAccess = false;

		var isBetaTester = false;
		if (this.state.profile.user_id !== undefined) {
			isBetaTester = Users.IsBetaTester(this.state.profile.user_id);
		}
		
		if (isBetaTester) {
			console.log('WELCOME BETA TESTER')
		}

		if(moment().isAfter(CST_PROMO_DATE_01A) && moment().isBefore(CST_PROMO_DATE_01B)) {
			specialAccess = true;
			console.log('ACCES PROMOTIONNEL - MARS 2018');
		}

		// console.log('playerId');
		// console.log(playerId);

		// Loggued in or special access ?
		if (!this.state.isAuthenticated) {
			return (
				<div>
					<p>Vous devez être connecté pour visualiser votre tableau de bord.<br/>
					Cliquez sur <b>Se connecter</b> dans la barre de gauche.<br/></p>
					{specialAccess ? this.dispPromoMessage() : null}
				</div>
			);
		}

		else if (!this.state.user.memberActive && !specialAccess) {
			return (
				<div>
					<p>Vous devez être abonné pour visualiser votre tableau de bord.<br/>
					Cliquez ici pour plus d'information sur les abonnements.</p>
					<Link to='/userAccount' className="btn btn-primary"> Abonnement </Link>
				</div>
			);
		}

		else if (specialAccess && playerId.toString() === '0') {
			return (
				<div>
					<p>Vous devez associer votre <b>PROFIL STATISTIQUE</b> dans la section <b>Votre Compte</b><br/>
					(Informations utilisateur - Modifier votre profil)</p>
					<Link to='/userAccount' className="btn btn-primary"> Votre Compte </Link>
				</div>
			);

		} else {
			return (
				<div>
					{this.dispSelectorsA()}
					{this.dispSelectorsB()}

					{(this.state.dashboardOption === 0) ? 
						<PlayerDashboardOptA playerId={playerId} resultsType={resultsType} leagueType={leagueType}/> : null}
					{(this.state.dashboardOption === 1) ? 
						<PlayerDashboardOptB playerId={playerId} resultsType={resultsType} leagueType={leagueType}/> : null}
					{(this.state.dashboardOption === 2) ? 
						<DashMod_Summary01 playerId={playerId} resultsType={resultsType} leagueType={leagueType}/> : null}
     		</div>
     	);
		}
	}

	dispSelectorsA() {
		return (
			<div>
				{this.displayPlayerIdSelector()}
				<div>
					<div className="row row-margin-bottom-20">
						{this.displayResultsTypeSelector()}
						{this.displayLeagueTypeSelector()}
	     		</div>
	   		</div>
     		<hr/>
   		</div>
		);
	}

	dispSelectorsB() {
		var btnClass = ['btn-secondary', 'btn-secondary', 'btn-secondary'];
		btnClass[this.state.dashboardOption] = 'btn-primary';

		return (
			<div>
				<div className="row">
				<div className="col-md-12">
					<button className={"btn " + btnClass[0] + " btn-margin-right-10"} onClick={this.btnClicked.bind(this, 0)}
						role="button">Sommaires et Évolution</button>
					<button className={"btn " + btnClass[1] + " btn-margin-right-10"} onClick={this.btnClicked.bind(this, 1)}
						role="button">Matchs et Affrontements</button>
					<button className={"btn " + btnClass[2]} onClick={this.btnClicked.bind(this, 2)}
						role="button">Ligues et saisons</button> 
				</div>
				</div>

				<hr/>
   		</div>
		);
	}

	btnClicked(btnIdx) {
		if (this.state.dashboardOption !== btnIdx) {
			this.setState({
				dashboardOption: btnIdx
			});
		}
	}

	displayPlayerIdSelector() {
    return (
			<div className="row row-margin-bottom-20">
				<div className="col-md-10">
				<span className="text-uppercase font-weight-bold">Joueur</span><br/>
				<span>Rechercher un joueur en entrant quelques lettres de son prénom ou de son nom de famille</span>
			</div>
			<div className="col-md-4">
				<AutoSuggestPlayer theme={autoSuggTheme} playerId={this.state.user.playerId} dataChange={this.handlePlayerChange} />
			</div>
			</div>
    );
	}

	displayResultsTypeSelector() {
    return (
			<div className="col-md-3">
			<span className="text-uppercase font-weight-bold">Types de Résultats</span>
				<select className="form-control" 
					value={this.state.resultsTypeSelectorValue} onChange={this.handleResultsTypeChange}>
	        
	        <option value={0} key={"restype0"}>Ligues et tournois</option>
					<option value={1} key={"restype1"}>Ligues seulement</option>
					<option value={2} key={"restype2"}>Tournois seulement</option>
      	</select>
			</div>
    );
	}

	displayLeagueTypeSelector() {

    return (
			<div className="col-md-3">
				<span className="text-uppercase font-weight-bold">Type de jeu</span>
        <select className="form-control" 
        	value={this.state.leagueTypeSelectorValue} onChange={this.handleLeagueTypeChange}>
	        
	        <option value={0} key={"lgtype0"}>Jeu du 8</option>
	        <option value={1} key={"lgtype1"}>Jeu du 9</option>
					<option value={2} key={"lgtype2"}>Jeu du 10</option>

      	</select>
			</div>
    );
	}

	dispPromoMessage() {
		return (
			<div>
				<img className="img-fluid" src="./img/abc.png" alt="promo-6-mois-40.00" width="200"/><br/><br/>
				<h5>Prix Spéciaux sur les Abonnements !</h5>
			</div>
		);
	}

	displayDashboardPanel_chart1() {
		return (
			<div className="col-md-8">
    	<div className="card">
	    	<div className="card-header">
	      	Dernières semaines
	{/*              		
	    		<div className="card-actions">
	      	<a href="http://www.chartjs.org"><small className="text-muted">docs</small></a>
	    		</div>
	*/}
	    	</div>
		  	<div className="card-block">
				<div className="chart-wrapper">
					<Bar data={bar} options={{ maintainAspectRatio: false }} />
				</div>
		  	</div>
    	</div>
			</div>
		);
	}

	displayDashboardPanel8() {
		return (
			<div className="col-md-8">
			<div className="card">
				<div className="card-header">
					<i className="fa fa-th-large"></i>
					Stats #1
				</div>

				<div className="card-block">

					<table className="table table-sm">
					<thead>
						<tr>
						<th>Username</th>
						<th>Date registered</th>
						<th>Role</th>
						<th>Status</th>
						</tr>
					</thead>

					<tbody>
						<tr>
							<td>Carwyn Fachtna</td>
							<td>2012/01/01</td>
							<td>Member</td>
							<td><span className="badge badge-success">V</span></td>
						</tr>

						<tr>
							<td>Nehemiah Tatius</td>
							<td>2012/02/01</td>
							<td>Staff</td>
							<td><span className="badge badge-danger">D</span></td>
						</tr>
					</tbody>
					</table>

				</div>
			</div>
			</div>
		)
	}

	displayDashboardPanel4() {
		return (
			<div className="col-md-4">
			<div className="card">
				<div className="card-header">
					<i className="fa fa-th-large"></i>
					Stats #1
				</div>

				<div className="card-block">

					<table className="table table-sm">
					<thead>
						<tr>
						<th>Username</th>
						<th>Status</th>
						</tr>
					</thead>

					<tbody>
						<tr>
							<td>Carwyn Fachtna</td>
							<td><span className="badge badge-success">Active</span></td>
						</tr>

						<tr>
							<td>Nehemiah Tatius</td>
							<td><span className="badge badge-danger">Banned</span></td>
						</tr>
					</tbody>
					</table>

				</div>
			</div>
			</div>
		)
	}

	handlePlayerChange(dataValue) {
		var user = this.state.user;
		user.playerId = dataValue;
    this.setState({
    	user: user
    });
	}

	handleResultsTypeChange(e) {
		var resultsType = myConstClass.RESTYPE_ALL;

		if (e.target.value === '0') {
			resultsType = myConstClass.RESTYPE_ALL;
		}
		if (e.target.value === '1') {
			resultsType = myConstClass.RESTYPE_LEAGUE;
		}
		if (e.target.value === '2') {
			resultsType = myConstClass.RESTYPE_TOURNAMENT;
		}

		this.setState({
			resultsTypeSelectorValue: e.target.value,
			resultsType: resultsType	
		});
	}

	handleLeagueTypeChange(e) {
		var leagueType = myConstClass.LGTYPE_8B;
		if (e.target.value === '0') {
			leagueType = myConstClass.LGTYPE_8B;
		}
		if (e.target.value === '1') {
			leagueType = myConstClass.LGTYPE_9B;
		}
		if (e.target.value === '2') {
			leagueType = myConstClass.LGTYPE_10B;
		}

		this.setState({
			leagueTypeSelectorValue: e.target.value,
			leagueType: leagueType
		});
	}

}

export default playerDashboard;
